export default __webpack_public_path__ + "static/media/Smart Dis.1d9f2fbf.png";